// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2-fTy","footer":"ChangeClinic_footer__3q6ft"};